"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _md = _interopRequireDefault(require("md5"));

var _react = require("react");

var _constants = require("../constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function getImageSize(size) {
  var baseImageSize = size === _constants.sizes.medium ? 36 : 60;
  var multiplier = Math.ceil(window.devicePixelRatio || 1);
  return baseImageSize * multiplier;
}

function getGravatarUrl(email, size) {
  var id = email && (0, _md.default)(email);
  var s = size && getImageSize(size);
  return id && s ? "https://secure.gravatar.com/avatar/".concat(id, "?s=").concat(s, "&d=404") : '';
}

function useGravatar(_ref) {
  var email = _ref.email,
      size = _ref.size;

  var _useState = (0, _react.useState)(!!email),
      _useState2 = _slicedToArray(_useState, 2),
      shouldUseGravatar = _useState2[0],
      setShouldUseGravatar = _useState2[1];

  var gravatarUrl = getGravatarUrl(email, size);
  (0, _react.useEffect)(function () {
    setShouldUseGravatar(!!gravatarUrl);
  }, [gravatarUrl]);
  return [{
    alt: '',
    onError: function onError() {
      setShouldUseGravatar(false);
    },
    role: 'presentation',
    src: gravatarUrl
  }, shouldUseGravatar];
}

var _default = useGravatar;
exports.default = _default;